import {
  Box,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { FaInstagram, FaWhatsapp } from 'react-icons/fa';
import { CiFacebook } from 'react-icons/ci';
import { MdOutlineMail } from 'react-icons/md';
import { IoCallOutline } from 'react-icons/io5';
import { useNavigate, useLocation } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme: any = useTheme();

  const openGmail = () => {
    const recipient = theme?.socialMediaLinks?.email;
    const mailtoLink = `mailto:${recipient}`;
    const gmailWebLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${recipient}`;

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      window.location.href = mailtoLink;
    } else {
      window.open(gmailWebLink, '_blank');
    }
  };
  const smallMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isMobile = /iPhone|Android/i.test(navigator.userAgent);
  const whatsappUrl = isMobile
    ? `whatsapp://send?phone=${theme?.socialMediaLinks?.whatsapp}`
    : `https://web.whatsapp.com/send?phone=${theme?.socialMediaLinks?.whatsapp}`;
  return (
    <Box>
      <Box sx={{ backgroundColor: '#ffffff', textAlign: 'center' }}>
        <Container sx={{ py: { xs: 4, sm: 5 } }}>
          <Box
            mb={5}
            sx={{
              paddingLeft: { md: '108px' },
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <img
              height='auto'
              width={'200px'}
              src={theme?.logo}
              alt='Snapcity Logo'
            />
          </Box>

          <Box
            display='flex'
            // flexWrap='wrap'
            flexDirection={{ xs: 'column', md: 'row' }}
            justifyContent='space-around'
            alignItems={{ xs: 'center', md: 'flex-start' }}
            gap={{ xs: 4, sm: 5, md: 6 }}
          >
            <Box
              display='flex'
              flexDirection='column'
              alignItems='center'
              gap={1}
              sx={{ width: { xs: '100%', sm: 'auto' } }}
            >
              <Typography
                variant='h6'
                sx={{
                  fontSize: { xs: '16px', sm: '18px', md: '20px' },
                  fontWeight: 400,
                }}
              >
                Contact Us
              </Typography>

              <Typography
                display='flex'
                alignItems='center'
                sx={{
                  cursor: 'pointer',
                  fontWeight: 600,
                  fontSize: { xs: '16px', sm: '18px', md: '20px' },
                }}
                onClick={() => {
                  window.open(whatsappUrl, '_blank');
                }}
              >
                <IoCallOutline
                  style={{
                    height: 20,
                    width: 20,
                    marginRight: 8,
                  }}
                />
                +91 9130901234
              </Typography>

              <Typography
                display='flex'
                alignItems='center'
                sx={{
                  cursor: 'pointer',
                  fontWeight: 600,
                  fontSize: { xs: '16px', sm: '18px', md: '20px' },
                }}
                onClick={openGmail}
              >
                <MdOutlineMail
                  style={{
                    height: 20,
                    width: 20,
                    marginRight: 8,
                  }}
                />
                {theme?.socialMediaLinks?.email}{' '}
              </Typography>

              <Box display='flex' gap={3}>
                <a
                  href={theme?.socialMediaLinks?.instagram}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <FaInstagram
                    style={{ color: 'black', height: 24, width: 24 }}
                  />
                </a>
                <a
                  href={theme?.socialMediaLinks?.facebook}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <CiFacebook
                    style={{ color: 'black', height: 24, width: 24 }}
                  />
                </a>
                <a href={whatsappUrl} target='_blank' rel='noopener noreferrer'>
                  <FaWhatsapp
                    style={{ color: 'black', height: 24, width: 24 }}
                  />
                </a>
              </Box>
            </Box>
            {/* <br /> */}
            <Box
              display='flex'
              flexDirection='column'
              alignItems='center'
              gap={1}
              sx={{ fontSize: { xs: '16px', sm: '18px', md: '20px' } }}
            >
              <Typography
                variant='h6'
                sx={{
                  fontSize: { xs: '16px', sm: '18px', md: '20px' },
                  fontWeight: 400,
                }}
              >
                Address
              </Typography>
              <Typography fontWeight={600}>
                Snapcity, Old Puna highway
              </Typography>
              <Typography fontWeight={600}>
                Behind Thanda Mamla and Indian
              </Typography>
              <Typography fontWeight={600}>
                Oil Petrol Pump, Talegaon Dabhade
              </Typography>
              <Typography fontWeight={600}>410506</Typography>
            </Box>

            <Box
              display='flex'
              flexDirection='column'
              alignItems='center'
              gap={1}
              sx={{
                width: { xs: '100%', sm: 'auto' },
                fontSize: { xs: '16px', sm: '18px', md: '20px' },
              }}
            >
              <Typography
                variant='h6'
                sx={{
                  fontSize: { xs: '16px', sm: '18px', md: '20px' },
                  fontWeight: 400,
                }}
              >
                Policies
              </Typography>

              {[
                { label: 'Privacy Policy', path: '/privacy-policy' },
                { label: 'Cancellation Policy', path: '/cancellation-policy' },
                { label: 'Refund Policy', path: '/refund-policy' },
              ].map(({ label, path }) => {
                const isActive = location.pathname === path;

                return (
                  <Typography
                    key={path}
                    fontWeight={isActive ? 700 : 600}
                    color={
                      isActive
                        ? 'var(--primary-color)'
                        : theme.palette.text.primary
                    }
                    sx={{
                      cursor: 'pointer',
                      '&:hover': { color: theme.palette.primary.main },
                      fontSize: { xs: '16px', sm: '18px', md: '20px' },
                    }}
                    onClick={() => navigate(path)}
                  >
                    {label}
                  </Typography>
                );
              })}
            </Box>
          </Box>
        </Container>
      </Box>

      <Box sx={{ py: 2, textAlign: 'center' }}>
        <Typography
          // variant='body2'
          textAlign={'center'}
          sx={{
            fontSize: { xs: '14px', sm: '15px', md: '16px' },
          }}
        >
          Copyright 2025 @ Snapcity | Designed By
          {smallMobile && <br />}{' '}
          <Box
            component='span'
            fontWeight='bold'
            sx={{
              cursor: 'pointer',

              '&:hover': {
                color: theme.palette.primary.main,
              },
            }}
            onClick={() => {
              window.open('https://www.infeonit.com/', '_blank');
            }}
          >
            Infeon IT Services Pvt. Ltd.
          </Box>
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
